import { at } from 'lodash'
import en from './en'
import es from './es'

let language
export function setLanguage(lang) {
  language = lang
}

const translations = { en, es }
export default function translate(key, lang) {
  const locale = lang || language
  return at(translations[locale], key)[0] || `t(${key}, ${locale})`
}



/** WEBPACK FOOTER **
 ** ../app/Translate/index.js
 **/